import { render, staticRenderFns } from "./AuthWarning.vue?vue&type=template&id=9ecf8fbe"
import script from "./AuthWarning.vue?vue&type=script&lang=ts"
export * from "./AuthWarning.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9ecf8fbe')) {
      api.createRecord('9ecf8fbe', component.options)
    } else {
      api.reload('9ecf8fbe', component.options)
    }
    module.hot.accept("./AuthWarning.vue?vue&type=template&id=9ecf8fbe", function () {
      api.rerender('9ecf8fbe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/alert/AuthWarning.vue"
export default component.exports